<template>
  <div class="loginPlane" v-if="loginShow">
    <div class="login">
      <div>
        <i @click="closeLogin" class="el-icon-close"></i>
      </div>
      <div class="login-logo">
        <img src="../assets/images/home/logoWord.png" alt="">
        <!-- <img src="../assets/images/home/logoRed.png" alt="">
        <img src="../assets/images/home/logoTextRed.png" alt=""> -->
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="账号密码登录" name="first"></el-tab-pane>
        <el-tab-pane label="验证码登录" name="second"></el-tab-pane>
      </el-tabs>
      <el-form :model="formList" ref="formList" :rules="rules">
        <el-form-item prop="mobile">
          <div class="leftItem">
            <div class="icon-bk">
              <img src="../assets/images/home/mobile.png" alt="">
            </div>
            <el-input placeholder="请输入您的手机号" v-model="formList.mobile"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password" v-if="activeName === 'first'">
          <div class="leftItem">
            <div class="icon-bk">
              <img src="../assets/images/home/password.png" alt="">
            </div>
            <el-input onfocus="this.type='password'" type="text" placeholder="请输入密码" v-model="formList.password"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="captcha" :rules="[{required: true, message: '验证码不能为空'}]"  v-if="activeName === 'first'">
          <div class="rightItem">
            <el-input
              class="code-input"
              placeholder="请输入验证码"
              v-model="formList.captcha"
              maxlength="10"
            ></el-input>
            <img class="verificationCode" :src="'data:image/png;base64,'+captchaImg" />
            <div class="refresh" @click="getImgCodes">
              <span>换一换</span>
              <i v-if="!imgCodeLoad" class="el-icon-refresh refresh1"></i>
              <i v-else class="el-icon-loading refresh1"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item prop="captcha" :rules="[{required: true, message: '验证码不能为空'}]"  v-if="activeName !== 'first'">
          <div class="rightItem">
            <el-input
              placeholder="请输入验证码"
              v-model="formList.captcha"
              maxlength="10"
            ></el-input>
            <el-button v-if='isSendCode' @click='verificationCodeEvent' class='verificationCodeBtn' :disabled='isSendCode'>{{this.isNumber+'s重新获取'}}</el-button>
            <el-button v-else @click='verificationCodeEvent' class='verificationCodeBtn' :disabled="formList.mobile === '' || isSendCode">获取验证码</el-button>
          </div>
        </el-form-item>

        <div class="handleBox">
          <el-button class="handle" @click="loginEvent">立即登录</el-button>
        </div>

        <div class="foot-login">
          <span>
            没有账号?
            <a class="curter" style="color:#A0393E;" @click="toRegist(1)">立即注册</a>
          </span>
          <span @click="toRegist(2)" class="forget-password curter">忘记密码?</span>
        </div>

        <!-- <div class="link-logo">
          <img src="../assets/images/home/QQ.png" alt="">
          <img src="../assets/images/home/wechat.png" alt="">
          <img src="../assets/images/home/ICBC.png" alt="">
        </div> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import { getImgCode, userLogin, codeLogin, messageAuthentication } from '@/api/login.js'
import { config } from '@/constant/config'
import { getInfo } from '@/api/personal'

export default {
  name: 'loginPlane',
  props: ['loginShow'],
  watch: {
    loginShow (val) {
      if (val) {
        this.getImgCodes()
      }
    }
  },
  data () {
    var validateUsername = (rule, value, callback) => {
      if (this.formList.mobile === '') {
        callback(new Error('请输入手机号'))
      } else if (
        this.formList.mobile.match(/^1[34578]\d{9}$/) === null
      ) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/.test(this.formList.password)) {
        callback(new Error('密码需要包含字母和数字，且不少于6位'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (this.formList.password === '') {
        callback(new Error('请再次输入密码'))
      } else if (this.formList.password2 !== this.formList.password) {
        console.log(value, this.formList.password)
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      formList: {
        mobile: '',
        captcha: '',
        password: '',
        password2: ''
      },
      rules: {
        mobile: [{ validator: validateUsername, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        password2: [{ validator: validatePass2, trigger: 'blur' }]
      },
      activeName: 'first',
      captchaImg: '', // 验证码图片
      imgCodeLoad: false,
      isSendCode: false,
      isNumber: 60,
      setIntervals: null
    }
  },
  methods: {
    test () {
      console.log(123)
    },
    verificationCodeEvent () {
      if (this.formList.mobile.match(/^1[34578]\d{9}$/) === null) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      this.isSendCode = true
      this.setIntervals = setInterval(() => {
        this.isNumber--
        if (this.isNumber <= 0) {
          this.isNumber = 60
          this.isSendCode = false
          clearInterval(this.setIntervals)
        }
      }, 1000)
      messageAuthentication({
        mobile: this.formList.mobile,
        asyn: '0',
        tenantId: config.TENANTID,
        merchantId: config.MERCHID
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('短信发送成功')
        } else {
          this.$message.error(res.error)
        }
      })
    },
    loginEvent () {
      this.$refs['formList'].validate((valid) => {
        if (valid) {
          if (this.activeName === 'first') {
            let data = {
              username: this.formList.mobile,
              password: this.formList.password,
              traceId: this.formList.traceId,
              captcha: this.formList.captcha
            }
            userLogin(data).then((res) => {
              if (res.code === 0) {
                this.$message.success('登录成功')
                sessionStorage.setItem('token', res.data.token)
                sessionStorage.setItem('mobile', this.formList.mobile)
                this.closeLogin()
                this.getInfo()
                this.$emit('loginOk')
              } else {
                this.$message.error(res.error)
              }
            })
          } else {
            let data = {
              username: this.formList.mobile,
              smsCode: this.formList.captcha
            }
            codeLogin(data).then((res) => {
              if (res.code === 0) {
                this.$message.success('登录成功')
                sessionStorage.setItem('token', res.data.token)
                sessionStorage.setItem('mobile', this.formList.mobile)
                this.getInfo()
                this.closeLogin()
                this.$emit('loginOk')
              } else {
                this.$message.error(res.error)
              }
            })
          }
        }
      })
    },
    hideCode (str, frontLen, endLen) {
      var len = str.length - frontLen - endLen
      var xing = ''
      for (var i = 0; i < len; i++) {
        xing += '*'
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
    },
    getInfo () {
      getInfo().then((res) => {
        if (res.code === 0) {
          if (res.data) {
            if (!res.data.phone) {
              res.data.phone = sessionStorage.getItem('mobile')
            }
            res.data.showPhone = this.hideCode(res.data.phone, 3, 4)
            res.data.avatarUrlShow = res.data.avatarUrl
            this.$store.dispatch('setUserInfo', res.data)
          }
        } else {
          this.$message.error(res.error)
        }
      })
    },
    closeLogin () {
      this.$refs['formList'].resetFields()
      this.$emit('closeLogin')
    },
    toRegist (i) {
      this.$refs['formList'].resetFields()
      this.$emit('registShowEvent', i)
    },
    backPassword () {
      this.$refs['formList'].resetFields()
      this.$emit('backPassword')
    },
    getImgCodes () {
      getImgCode().then((res) => {
        this.captchaImg = res.data.captchaImg
        this.formList.traceId = res.data.traceId
      })
    },
    refresh () {
      let item = document.getElementsByClassName('refresh1')[0]
      item.style.transform = 'rotate(' + 5 + 'deg)'
    }
  }
}
</script>

<style lang="scss" scoped>
.loginPlane {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2000;
  background: white;
  border: 2px solid #d3d3d3;
  width: 440px;
  border-radius: 10px;
  .login-logo {
    text-align: center;
    margin-bottom: 34px;
    img {

    }
  }
  .curter {
    cursor: pointer;
  }
}
.login {
  margin: 60px 50px 28px 50px;
  .leftItem {
    display: flex;
    border: 1px solid #BEC9DF;
    opacity: 1;
    border-radius: 4px;
    /deep/ .el-input {
      width: 300px;
      .el-input__inner {
        border: none;
      }
    }
    .icon-bk {
      display: flex;
      width: 40px;
      height: 40px;
      align-items: center;
      justify-content: center;
      color: white;
    }
  }
  .el-icon-close {
    cursor: pointer;
    position: absolute;
    top: 17px;
    right: 34px;
    font-size: 24px;
  }
  .el-input {
    width: 350px;
  }
  .code-input {
    width: 132px;
  }
  .rightItem {
    display: flex;
    justify-content: space-between;
    .verificationCode {
      width: 126px;
      height: 38px;
      float: right;
    }
  }
  .refresh {
    cursor: pointer;
    display: inline-block;
    margin-left: 15px;
  }
  .handle {
    width: 100%;
    background: #A0393E;
    color: #FFFFFF;
  }
  .foot-login {
    line-height: 40px;
    height: 40px;
    a {
      color: #c02020;
    }
    .forget-password {
      float: right;
    }
  }
}
.tiketType_box {
  margin-top: 20px;
}
.marquee-title {
  float: left;
  width: 80px;
  line-height: 58px;
  height: 58px;
  margin-right: 18px;
}
.marquee-title span {
  display: inline-block;
  color: #ec2f2f;
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
}
.marquee-title img {
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
marquee {
  overflow: hidden;
  float: left;
  width: calc(100% - 98px);
  display: block;
  line-height: 58px;
  height: 58px;
  color: #666;
  font-size: 12px;
}

.noticeBtn {
  cursor: pointer;
  float: right;
  line-height: 40px;
  text-align: center;
  background-color: #ffb000;
  padding: 0 15px;
  border-radius: 20px;
  &:hover {
    opacity: 0.8;
  }
  .ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    vertical-align: middle;
    background: url(../assets/images/notice.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .text {
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.buyticket {
  // margin-bottom: 40px;
  border-radius: 5px;
  .pane {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(20, 34, 44, 0.15);
    padding: 30px 60px;
    .buyticket-box {
      overflow: hidden;
      .buyticket-div {
        overflow: hidden;
        margin-bottom: 19px;
        .title {
          float: left;
          font-size: 16px;
          color: #333;
          font-weight: bold;
          line-height: 44px;
          height: 44px;
        }
        .buyticket-right {
          overflow: hidden;
          padding-left: 100px;
          // height: 44px;
          .select-list {
            float: right;
            text-align: right;
            > span {
              display: inline-block;
              margin: 0 7px;
              width: 130px;
              height: 44px;
              background: rgba(246, 246, 246, 1);
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              margin-bottom: 10px;
              > em {
                display: inline-block;
                width: 100%;
                height: 100%;
                line-height: 44px;
                border-radius: 6px;
                overflow: hidden;
                font-style: normal;
                &:hover {
                  opacity: 0.8;
                }
                &.active {
                  background: #241008;
                  color: #fff;
                }
                &.disable {
                  color: #cdcdcd;
                  cursor: no-drop;
                }
              }
            }
          }
          .select-btn {
            float: right;
            width: 130px;
            height: 44px;
            line-height: 44px;
            border-radius: 6px;
            .input-show {
              display: block;
              width: 100%;
              height: 100%;
              line-height: 44px;
              text-align: center;
              height: 44px;
              background: #f6f6f6;
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              outline: none;
              text-align: center;
              &.active {
                background: #241008;
                color: #fff;
              }
              &:hover {
                opacity: 0.8;
              }
            }
            .picker-options {
              display: block;
              width: 100%;
              height: 44px;
              line-height: 44px;
              .el-input {
                width: 100% !important;
                background: #f6f6f6;
              }
            }
          }
        }
      }
      .buyticket-footer {
        overflow: hidden;
        display: flex;
        border-top: 1px solid #f6f6f6;
        padding-top: 29px;
        margin-top: 31px;
        .booking-notice {
          flex: 1;
          height: 58px;
          line-height: 58px;
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            display: inline-block;
            font-size: 16px;
            color: #ec2f2f;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .booking-msg {
          flex: 1;
          overflow: hidden;
          line-height: 58px;
          text-align: right;
          .msg {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #333;
            span {
              display: inline-block;
              color: #ff4400;
              margin: 0 12px;
            }
          }
          .payBtn {
            display: inline-block;
            width: 140px;
            height: 58px;
            line-height: 58px;
            text-align: center;
            font-size: 18px;
            border-radius: 6px;
            background: #241008;
            color: #fff;
            margin-left: 42px;
            margin-right: 7px;
            cursor: pointer;
            &.disable {
              background: #f6f6f6;
              cursor: no-drop;
              color: #cdcdcd;
            }
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
    .dateSelect {
      margin-bottom: 16px;
      .label {
        font-weight: bold;
        line-height: 40px;
        margin-right: 15px;
      }
      .btn {
        display: inline-block;
        vertical-align: middle;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 15px;
        border-radius: 15px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .btn.right {
        float: right;
        /* right: 20px; */
      }
      .btn.current {
        color: #fff;
        background-color: #21a4ff;
      }
    }
    .ticketDetail /deep/ .el-table::before {
      height: 0;
    }
    .ticketDetail /deep/ th.is-leaf {
      background-color: #21a4ff;
      color: #fff;
      border-bottom: 12px solid #fff;
    }
    .ticketDetail /deep/ th.is-leaf:nth-child(1) {
      background: url(../assets/images/border_th_l.png) #21a4ff no-repeat left;
    }
    .ticketDetail /deep/ th.is-leaf:nth-last-child(2) {
      background: url(../assets/images/border_th_r.png) #21a4ff no-repeat right;
    }
    .ticketDetail /deep/ td {
      background-color: #f7f7f7;
      border-bottom: 12px solid #fff;
      padding: 10px 0;
    }
    .ticketDetail /deep/ td .cell {
      font-weight: bold;
    }
    .ticketDetail /deep/ td:nth-child(1) {
      background: url(../assets/images/border_td_l.png) #f7f7f7 no-repeat left;
    }
    .ticketDetail /deep/ td:nth-last-child(2) {
      background: url(../assets/images/border_td_r.png) #f7f7f7 no-repeat right;
    }
  }
}

.reserveBtn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #ffb000;
  cursor: pointer;
}
.reserveBtn:hover {
  background-color: #faab00;
}
.mb40 {
  margin-bottom: 40px;
}
.main-box {
  background: #ededed;
  padding-bottom: 35px;
}
.notice-dialog {
  .title {
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    padding-left: 20px;
    position: relative;
    margin-bottom: 34px;
    &::before {
      position: absolute;
      top: 50%;
      width: 3px;
      height: 14px;
      background: rgba(191, 147, 48, 1);
      border-radius: 2px;
      margin-top: -7px;
      left: 8px;
      content: "";
    }
  }
  .notice {
    display: block;
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
  }
  .btn {
    width: 130px;
    height: 44px;
    background: rgba(191, 147, 48, 1);
    border-radius: 6px;
    color: #fff;
    margin: 0 21px;
    &.cancal {
      background: #ccc;
      color: #333;
    }
  }
}
.dialog-login {
  iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
}
/deep/ .el-tabs__nav {
  .el-tabs__item {
    color: #0D111B;
  }
  .is-active {
    color: #A0393E
  }
  .el-tabs__active-bar {
    background-color: #A0393E !important;
  }
}
.link-logo {
  display: flex;
  justify-content: center;
  img {
    margin-right: 20px;
  }
}
</style>
